let id = 0;

export function uniqueId(prefix = "") {
  id ++;
  return `${prefix}${id}`;
}